<div
    class="col-sm-12 col-md-7 col-lg-8"
    [ngClass]="showMessagePanelForSmallScreen !== undefined ? (showMessagePanelForSmallScreen === true ? 'd-block' : 'd-none') : ''"
>
    <div id="message-panel-card" class="card card-border message-panel-height">
        <ng-container *ngIf="loadGroupChatPayload !== null">
            <div class="row px-4">
                <div class="col-xs-12 col-sm-12 my-3">
                    <div class="d-flex column-gap width-100 justify-content-between">
                        <div class="d-flex width-90">
                            <div class="d-flex flex-column justify-content-center mr-4 display-large-none">
                                <button class="plus-icon" title="Go Back" (click)="goToChatListPage()">
                                    <i class="fa fa-chevron-circle-left fa-lg"></i>
                                </button>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center flex-wrap max-width">
                                        <div
                                            *ngIf="
                                                (isInternal || isLoggedInMemberAGroupAdmin) &&
                                                loadGroupChatPayload.groupDetail.isEnabled === true
                                            "
                                            (click)="openGroupInfoDialog(groupMemberList, loadGroupChatPayload.groupDetail)"
                                        >
                                            <h4 class="cursorPointer overflow-ellipsis max-width">
                                                {{ loadGroupChatPayload.groupDetail.groupName }}
                                            </h4>
                                        </div>
                                        <div
                                            *ngIf="
                                                (!isInternal && !isLoggedInMemberAGroupAdmin) ||
                                                loadGroupChatPayload.groupDetail.isEnabled === false
                                            "
                                        >
                                            <h4 class="overflow-ellipsis max-width">
                                                {{ loadGroupChatPayload.groupDetail.groupName }}
                                            </h4>
                                        </div>
                                        <div class="ml-2">
                                            <span
                                                class="badge cursorPointer"
                                                (click)="gotoItineraryPage(loadGroupChatPayload.serviceRequestDetail.serviceRequestId)"
                                            >
                                                <span>{{ loadGroupChatPayload.serviceRequestDetail.tripId }}</span>
                                            </span>
                                        </div>
                                        <div
                                            *ngIf="loadGroupChatPayload.groupDetail.isEnabled === true"
                                            class="ml-2 cursorPointer refresh-button"
                                        >
                                            <i *ngIf="!isRefreshing" class="fa" (click)="isRefreshing = true; refreshMessagePanel()"
                                                >&#xf021;</i
                                            >
                                            <i *ngIf="isRefreshing" class="fa fa-refresh fa-spin"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex dark-grey mr-5">
                                    <span class="d-block overflow-ellipsis max-width">
                                        <span *ngIf="groupMemberListOnHeaderLoader"> Group Info </span>
                                        <span
                                            *ngIf="
                                                !groupMemberListOnHeaderLoader &&
                                                (isInternal || isLoggedInMemberAGroupAdmin) &&
                                                loadGroupChatPayload.groupDetail.isEnabled === true
                                            "
                                            class="cursorPointer"
                                            (click)="openGroupInfoDialog(groupMemberList, loadGroupChatPayload.groupDetail)"
                                        >
                                            {{ memberListToShowOnHeader.toString().split(',').join(', ') }}
                                        </span>
                                        <span
                                            *ngIf="
                                                !groupMemberListOnHeaderLoader &&
                                                ((!isInternal && !isLoggedInMemberAGroupAdmin) ||
                                                    loadGroupChatPayload.groupDetail.isEnabled === false)
                                            "
                                        >
                                            {{ memberListToShowOnHeader.toString().split(',').join(', ') }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            *ngIf="loadGroupChatPayload.groupDetail.isEnabled === true"
                            id="more-option-container"
                            class="d-flex flex-column text-danger cursorPointer justify-content-center width-10"
                            (click)="isMoreOptionVisible = !isMoreOptionVisible"
                        >
                            <i class="fa fa-ellipsis-v fa-lg"></i>
                        </div>
                        <div
                            *ngIf="isMoreOptionVisible"
                            class="card card-layout card-border more-info-container font-medium dark-grey px-0 py-3 cursorPointer"
                        >
                            <div
                                *ngIf="isInternal || isLoggedInMemberAGroupAdmin"
                                id="more1"
                                class="more-info-option"
                                (click)="openGroupInfoDialog(groupMemberList, loadGroupChatPayload.groupDetail)"
                            >
                                Group Info
                            </div>
                            <div id="more2" class="more-info-option" (click)="exitGroup()">Exit Group</div>
                            <div *ngIf="isDeleteGroupOptionVisible" id="more3" class="more-info-option" (click)="deleteGroup()">
                                Delete Group
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <mat-divider></mat-divider>

            <div id="message-section" class="row px-4 message-section">
                <div id="message-panel" class="col-xs-12 col-sm-12 p-4 height-100 scrollbarView">
                    <ng-container *ngIf="messageList.length > 0">
                        <ng-container *ngFor="let message of messageList; let i = index; trackBy: messageTrackBy">
                            <!-- INCOMING MESSAGE CONTAINER -->
                            <ng-container *ngIf="message.memberId !== user.memberId">
                                <div [id]="message.messageId" class="d-flex mt-2">
                                    <div
                                        [ngClass]="
                                            i > 0 && messageList[i].memberId === messageList[i - 1].memberId ? 'visibility-hidden' : ''
                                        "
                                    >
                                        <div
                                            *ngIf="checkIsProfilePicAvailable(message.memberId)"
                                            [ngClass]="isInternal ? 'cursorPointer' : ''"
                                            (click)="openMemberInfoDialog(message)"
                                        >
                                            <img
                                                class="profile-pic"
                                                [alt]="message.memberInitials"
                                                [src]="checkIsProfilePicAvailable(message.memberId)"
                                            />
                                        </div>
                                        <div
                                            *ngIf="!checkIsProfilePicAvailable(message.memberId)"
                                            class="initials-container"
                                            [ngClass]="isInternal ? 'cursorPointer' : ''"
                                            [style.background]="
                                                memberProfileColor(message.memberId) ? memberProfileColor(message.memberId) : '#8A8A8A'
                                            "
                                            (click)="openMemberInfoDialog(message)"
                                        >
                                            <span class="initials">{{ message.memberInitials }}</span>
                                        </div>
                                    </div>
                                    <div
                                        class="message-container text-message incoming-message-container-bg-color ml-5"
                                        [ngClass]="{
                                            'media-file': message.fileName !== null && messageAttachmentLoader,
                                            'tri-right left-top mt-4':
                                                (i > 0 && messageList[i].memberId !== messageList[i - 1].memberId) || i === 0,
                                        }"
                                    >
                                        <div class="message-text-container px-3 pb-2">
                                            <h5
                                                class="my-0 mb-2"
                                                [ngClass]="isInternal ? 'cursorPointer' : ''"
                                                (click)="openMemberInfoDialog(message)"
                                            >
                                                {{ message.memberName }}
                                            </h5>
                                            <ng-container *ngIf="message.fileName">
                                                <div
                                                    *ngIf="messageAttachmentLoader && !message.filePath"
                                                    class="background-white d-flex align-items-center justify-content-center height-10"
                                                >
                                                    <mat-spinner [diameter]="25"></mat-spinner>
                                                </div>
                                                <div
                                                    *ngIf="!messageAttachmentLoader && message.filePath"
                                                    class="d-flex justify-content-center align-content-center background-white cursorPointer"
                                                    (click)="openImagePreview(message.filePath)"
                                                >
                                                    <img class="image-message" alt="Image" [src]="message.filePath" />
                                                </div>
                                                <div
                                                    *ngIf="!messageAttachmentLoader && message.filePath === null"
                                                    class="background-white d-flex align-items-center justify-content-center"
                                                >
                                                    <mat-icon class="alert-icon">error_outline</mat-icon>
                                                </div>
                                            </ng-container>
                                            <app-read-more [maxLengthToShow]="800" [text]="message.messageText"> </app-read-more>
                                            <div class="d-flex justify-content-end light-grey font-small">
                                                <span>
                                                    {{ message.messageSendTime | localDate: timeZone }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- OUTGOING MESSAGE CONTAINER -->
                            <ng-container *ngIf="message.memberId === user.memberId">
                                <div [id]="message.messageId" class="d-flex justify-content-end mt-2">
                                    <div
                                        class="message-container text-message outgoing-message-container-bg-color mr-5"
                                        [ngClass]="{
                                            'media-file': message.fileName !== null && messageAttachmentLoader,
                                            'tri-right right-top mt-4':
                                                (i > 0 && messageList[i].memberId !== messageList[i - 1].memberId) || i === 0,
                                        }"
                                    >
                                        <div class="message-text-container px-2 pb-2">
                                            <ng-container *ngIf="message.fileName">
                                                <div
                                                    *ngIf="messageAttachmentLoader && !message.filePath"
                                                    class="background-white d-flex align-items-center justify-content-center height-10"
                                                >
                                                    <mat-spinner [diameter]="25"></mat-spinner>
                                                </div>
                                                <div
                                                    *ngIf="!messageAttachmentLoader && message.filePath"
                                                    class="d-flex justify-content-center align-content-center background-white cursorPointer"
                                                    (click)="openImagePreview(message.filePath)"
                                                >
                                                    <img class="image-message" alt="Image" [src]="message.filePath" />
                                                </div>
                                                <div
                                                    *ngIf="!messageAttachmentLoader && message.filePath === null"
                                                    class="background-white d-flex align-items-center justify-content-center"
                                                >
                                                    <mat-icon class="alert-icon">error_outline</mat-icon>
                                                </div>
                                            </ng-container>
                                            <app-read-more [maxLengthToShow]="800" [text]="message.messageText"> </app-read-more>
                                            <div class="d-flex justify-content-end light-grey font-small">
                                                <span *ngIf="message.messageSendTime === null && message.isSending">
                                                    <mat-spinner [diameter]="15"></mat-spinner>
                                                </span>
                                                <span
                                                    *ngIf="
                                                        message.messageSendTime !== null &&
                                                        !message.isSending &&
                                                        message.isSentSuccessful === true
                                                    "
                                                >
                                                    {{ message.messageSendTime | localDate: timeZone }}
                                                </span>
                                                <span *ngIf="!message.isSending && message.isSentSuccessful === false">
                                                    <mat-icon class="alert-icon">error_outline</mat-icon>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <!-- INPUT FIELD CONTAINER -->
            <div class="row px-4">
                <div class="col-xs-12 col-sm-12 my-4 background-white">
                    <div class="d-flex align-items-end justify-content-center col-gap">
                        <ng-container *ngIf="loadGroupChatPayload.groupDetail.isEnabled === true; else noInputAllowedBlock">
                            <div class="input-bar flex-grow-1 text radius">
                                <ng-container *ngIf="imagePreview">
                                    <div class="image-preview-section d-flex justify-content-center">
                                        <span [ngClass]="isUploadFileLoading ? 'upload-image-loader-container' : ''">
                                            <span
                                                *ngIf="isUploadFileLoading"
                                                class="align-self-center img-align-center width-100-percent d-inline-block"
                                            >
                                                <mat-spinner [diameter]="20"></mat-spinner>
                                            </span>
                                            <span *ngIf="!isUploadFileLoading" class="image-container-width img-align-center">
                                                <img
                                                    id="imagePreview"
                                                    class="image-preview cursorPointer"
                                                    loading="eager"
                                                    [src]="imageURL"
                                                    (click)="openImagePreview(imageURL)"
                                                />
                                            </span>
                                        </span>
                                        <span class="cursorPointer">
                                            <mat-icon class="cancel-icon" (click)="closeImagePreview()">cancel</mat-icon>
                                        </span>
                                    </div>
                                </ng-container>
                                <div class="d-flex justify-content-center align-items-end col-gap text-input p-3">
                                    <mat-icon
                                        class="dark-grey radius-100 cursorPointer chat-icon pr-2"
                                        [emojiPickerDirection]="'top' || 'right' || 'bottom' || 'left'"
                                        [(emojiPickerIf)]="toggleEmojiPicker"
                                        (click)="toggleEmojiPicker = !toggleEmojiPicker; updateCSSForEmojiPicker()"
                                        (emojiPickerSelect)="selectEmoji($event)"
                                        >sentiment_very_satisfied</mat-icon
                                    >
                                    <textarea
                                        id="message"
                                        #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMaxRows="6"
                                        cdkAutosizeMinRows="1"
                                        cdkTextareaAutosize
                                        matInput
                                        name="message"
                                        placeholder="Text message"
                                        type="text"
                                        [(ngModel)]="textMessageBody"
                                        (ngModelChange)="isSendButtonDisabled()"
                                    ></textarea>
                                    <label class="cursorPointer upload-image-container mb-0" for="file">
                                        <mat-icon class="chat-icon"
                                            >attach_file
                                            <input
                                                id="file"
                                                class="d-none"
                                                accept="image/png, image/gif, image/jpeg, image/jpg"
                                                hidden
                                                name="file"
                                                type="file"
                                                [(ngModel)]="fileAttachment"
                                                (change)="uploadImage($event)"
                                            />
                                        </mat-icon>
                                    </label>
                                </div>
                            </div>
                            <div class="action-buttons">
                                <button
                                    mat-mini-fab
                                    class="send-message-button"
                                    title="Send Message"
                                    type="submit"
                                    [disabled]="sendMessageBtnDisabled"
                                    (click)="uploadMessage()"
                                >
                                    <mat-icon>send</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                        <ng-template #noInputAllowedBlock>
                            <span class="text-color">
                                Group is no longer active as Service Request is
                                <strong>{{ loadGroupChatPayload.serviceRequestDetail.serviceRequestStatus }}</strong>
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="loadGroupChatPayload === null">
            <!-- TODO: UI to show when there is no chat group loaded -->
        </ng-container>
    </div>
</div>
